import { GROUP_SESSION_STATUS_TYPES } from "constants/groupSessionStatusTypes";
import { GROUP_SESSION_PATIENT_STATUS_TYPES } from "constants/groupSessionPatientStatusTypes";

/**
 * Check if a group session is cancelled by pro
 * @param groupSession
 */
export function isGroupSessionCancelledByPro(groupSession) {
  return (
    groupSession.status === GROUP_SESSION_STATUS_TYPES.cancelled ||
    groupSession.patients?.some(
      (el) =>
        el.attend_status ===
        GROUP_SESSION_PATIENT_STATUS_TYPES.cancelled_group_session,
    )
  );
}

/**
 * Check if a group session is cancelled by all patients
 * @param groupSession
 */
export function isGroupSessionCancelledByAllPatients(groupSession) {
  return groupSession.patients?.every(
    (el) =>
      el.attend_status ===
      GROUP_SESSION_PATIENT_STATUS_TYPES.cancelled_by_patient,
  );
}

/**
 * Check if a group session is cancelled by current / first patient
 * @param groupSession
 */
export function isGroupSessionCancelledByCurrPatient(groupSession) {
  return (
    groupSession.patients &&
    groupSession.patients[0]?.attend_status ===
      GROUP_SESSION_PATIENT_STATUS_TYPES.cancelled_by_patient
  );
}
